// The stored roles that work in the admin area (J/authority/Permission): an admin, or a team member
// with fewer rights. Their home is the admin dashboard. Kept apart from authUtils so the many tests
// that mock authUtils still get the real list.
export const STAFF_ROLES = ['ADMIN', 'TEAM'];
export const ADMIN_ROLE = 'ADMIN';
export const PROGRAM_EDITOR_ROLE = 'PROGRAM_EDITOR';

export const isStaffRole = (role) => STAFF_ROLES.includes(role);
export const isAdminRole = (role) => role === ADMIN_ROLE;
export const isProgramEditorRole = (role) => role === PROGRAM_EDITOR_ROLE;

// A session's full role set (GET /api/me): staff means any of STAFF_ROLES. An account can hold
// PROGRAM_EDITOR only as a computed extra role (its stored role stays MEMBER), so the two checks are
// separate.
export const isStaffRoles = (roles) => (roles || []).some(isStaffRole);
